import axios from "axios";

export function getQuiz(){
    return axios.request({
        method:'GET',
        url:'/api/quiz/getQuiz'
    })
}
export function enableQuestion(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'/api/quiz/enableQuestion'
    })
}
export function updateQuiz(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'/api/quiz/updateQuiz'
    })
}